// import { AsyncLocalStorage } from 'angular-async-local-storage';
import { Injectable } from '@angular/core';
// import * as JWT from 'jwt-decode';
import { StorageKeyEnum } from './storageKeyEnum.enum';
import { StorageMap } from '@ngx-pwa/local-storage';
import { Observable } from 'rxjs';
// import { Observable } from 'rxjs/Observable';

@Injectable()
export class StorageService {
  constructor(private _localStorage: StorageMap) {}

  // tslint:disable-next-line:member-ordering
  private myStorage = window.localStorage;

  getData(key: StorageKeyEnum): Observable<any> {
    return this._localStorage.get('carrier-'+key.toString());
  }
  setData<TData>(key: StorageKeyEnum, data: TData): Observable<boolean> {
    return this._localStorage.set('carrier-'+key.toString(), data);
  }

  getDataSync<TData>(key: StorageKeyEnum) {
    return JSON.parse(this.myStorage.getItem('carrier-'+key.toString()));
  }
  setDataSync<TData>(key: string, data: string) {
    this.myStorage.setItem('carrier-'+key.toString(), data);
  }
  getDataSyncString(key: string) {
    return JSON.parse(this.myStorage.getItem('carrier-'+key.toString()));
  }
  deleteData(key: StorageKeyEnum): Observable<boolean> {
    return this._localStorage.delete('carrier-'+key.toString());
  }
}
